import { getToken } from "../utils/commonFunctions";
import api from "./api";

const PUBLIC_ROUTES = ["login", "forgot-password", "register", "documentation"];

/**
 * Initializes authentication checks and Axios interceptors.
 * @param {Function} navigate - React Router's navigate function.
 */
export const initializeAuth = (navigate) => {
  const TOKEN = getToken();

  // Check if the current route is public
  const isPublicPage = PUBLIC_ROUTES.some((route) =>
    window.location.pathname.includes(route)
  );

  // Redirect to login if no token and not a public page
  if (!TOKEN && !isPublicPage) {
    navigate("/login");
    return;
  }

  // Set the Authorization header globally in Axios instance
  if (TOKEN) {
    api.defaults.headers.common["Authorization"] = `Bearer ${TOKEN}`;
  }
};
